import { type FC } from 'react';
import {
  renderDefaultCell,
  renderPercentCell
} from '../../../../TableContainer/TableUtilities/defaultCells';

interface ILeadDemographicCellComponent {
  row: Record<string, string>;
  column: Record<string, string>;
}

export const LeadDemographicCellComponent: FC<
  ILeadDemographicCellComponent
> = ({ row, column: { name } }) => {
  if (name === 'percent') {
    return renderPercentCell(row[name]);
  }

  return renderDefaultCell(row[name]);
};
